import { render } from "./ComparisonPerformanceReport.vue?vue&type=template&id=6b8856ee&scoped=true"
import script from "./ComparisonPerformanceReport.vue?vue&type=script&lang=js"
export * from "./ComparisonPerformanceReport.vue?vue&type=script&lang=js"

import "./ComparisonPerformanceReport.vue?vue&type=style&index=0&id=6b8856ee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b8856ee"]])

export default __exports__
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtnGroup,QBtn,QTooltip,QCheckbox,QBtnDropdown});qInstall(script, 'directives', {ClosePopup});
